// @flow
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import {
    Dialog,
    DialogHeader,
    DialogContent,
    Heading
} from '@locus-taxy/neo-ui';

import AccessDeniedMessage from './AccessDeniedMessage';

type Props = {
    action: string,
    onDismiss: () => void
};

const AccessDeniedDialog = ({ action, onDismiss }: Props): React.Node => {
    const { t } = useTranslation();

    return (
        <Dialog isOpen onDismiss={onDismiss}>
            <DialogHeader>
                <Heading size="large">
                    {t('translations:accessDenied.page.title')}
                </Heading>
            </DialogHeader>
            <DialogContent>
                <AccessDeniedMessage action={action} />
            </DialogContent>
        </Dialog>
    );
};

export default AccessDeniedDialog;
